import type { Configurator } from './configurator.model'
import { z } from 'zod'
import { directusImageDtoSchema, transformDirectusImageDtoToDirectusImage } from '../directus/directusImageDto.model'
import { configuratorPoolDtoSchema, transformConfiguratorPoolDtoToConfiguratorPool } from './configuratorPoolDto.model'

export const configuratorDtoSchema = z.object({
  id: z.number(),
  translations: z.array(z.object({
    id: z.number(),
    label: z.string(),
    form_title: z.string(),
    form_description: z.string(),
    languages_code: z.string(),
  })),
  form: z.string(),
  pools: z.array(configuratorPoolDtoSchema),
  background_image_day: directusImageDtoSchema,
  background_image_night: directusImageDtoSchema,
})

export type ConfiguratorDto = z.infer<typeof configuratorDtoSchema>

export function transformConfiguratorDtoToConfigurator(configuratorDto: ConfiguratorDto): Configurator {
  return {
    id: configuratorDto.id,
    form: configuratorDto.form,
    translations: configuratorDto.translations,
    pools: configuratorDto.pools.map(configuratorPoolDto => transformConfiguratorPoolDtoToConfiguratorPool(configuratorPoolDto)),
    backgroundImageDay: transformDirectusImageDtoToDirectusImage(configuratorDto.background_image_day),
    backgroundImageNight: transformDirectusImageDtoToDirectusImage(configuratorDto.background_image_night),
  }
}
